module.exports = __webpack_public_path__ + "static/portrait-man-face-2e69be5a492cf7f32b6c5db9481fe23d.jpg";